// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
  successBg: '#EBF5EF', dangerBg: '#FDECEA', warningBg: '#FBF3E8',
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '20px', fontFamily: 'Georgia, serif',
  },
  modal: {
    background: C.card, borderRadius: '16px', width: '100%',
    maxWidth: '580px', maxHeight: '90vh', overflowY: 'auto',
    boxShadow: '0 8px 40px rgba(44,29,20,0.2)',
    border: `1px solid ${C.border}`,
  },
  header: {
    padding: '24px 28px 0', display: 'flex',
    justifyContent: 'space-between', alignItems: 'center',
  },
  title: { fontSize: '22px', fontWeight: '700', color: C.brown },
  closeBtn: {
    background: 'none', border: 'none', fontSize: '22px',
    cursor: 'pointer', color: C.muted, padding: '0', lineHeight: 1,
  },
  body: { padding: '20px 28px 28px' },
  serviceHeader: {
    display: 'flex', alignItems: 'center', gap: '14px',
    marginBottom: '20px', padding: '16px',
    background: C.bg, borderRadius: '12px', border: `1px solid ${C.border}`,
  },
  serviceIcon: { fontSize: '36px' },
  serviceName: { fontSize: '18px', fontWeight: '700', color: C.brown },
  serviceType: { fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginTop: '2px' },
  detailGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: '10px', marginBottom: '16px',
  },
  detailItem: {
    background: C.bg, borderRadius: '10px', padding: '12px 14px',
    border: `1px solid ${C.border}`,
  },
  detailLabel: {
    fontSize: '10px', color: C.muted, letterSpacing: '1.5px',
    textTransform: 'uppercase', marginBottom: '4px',
    fontFamily: 'Calibri, sans-serif',
  },
  detailValue: { fontSize: '14px', fontWeight: '600', color: C.brown },
  detailEmpty: { fontSize: '13px', color: C.muted, fontStyle: 'italic' },
  sectionTitle: {
    fontSize: '11px', color: C.muted, letterSpacing: '2px',
    textTransform: 'uppercase', marginBottom: '12px',
    fontFamily: 'Calibri, sans-serif',
  },
  divider: { borderTop: `1px solid ${C.border}`, margin: '20px 0' },
  statusBadge: (status) => {
    const colors = {
      active: { bg: '#EBF5EF', color: C.success },
      scheduled: { bg: '#EBF5EF', color: C.success },
      'in progress': { bg: '#FBF3E8', color: C.amber },
      completed: { bg: '#EBF5EF', color: C.success },
      'on hold': { bg: '#FBF3E8', color: C.amber },
      cancelled: { bg: '#FDECEA', color: C.danger },
    }
    const c = colors[status?.toLowerCase()] || colors.active
    return {
      display: 'inline-block', fontSize: '11px', padding: '4px 12px',
      borderRadius: '20px', fontFamily: 'Calibri, sans-serif',
      background: c.bg, color: c.color, border: `1px solid ${c.color}44`,
    }
  },
  logEntry: {
    padding: '12px 0', borderBottom: `1px solid ${C.border}`,
  },
  logDate: {
    fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginBottom: '2px',
  },
  logNote: { fontSize: '14px', color: C.brown },
  logCost: {
    fontSize: '12px', color: C.success, fontFamily: 'Calibri, sans-serif', marginTop: '2px',
  },
  addLogRow: {
    display: 'flex', gap: '10px', alignItems: 'flex-start', marginTop: '12px',
  },
  logInput: {
    flex: 1, background: C.bg, border: `1px solid ${C.border}`,
    borderRadius: '8px', padding: '10px 14px', fontSize: '14px',
    fontFamily: 'Georgia, serif', color: C.brown, boxSizing: 'border-box',
    outline: 'none', resize: 'none',
  },
  logBtn: {
    background: C.amber, border: 'none', borderRadius: '8px',
    padding: '10px 16px', color: C.card, fontSize: '12px',
    fontWeight: '700', cursor: 'pointer', fontFamily: 'Georgia, serif',
    letterSpacing: '1px', whiteSpace: 'nowrap',
  },
  btnRow: { display: 'flex', gap: '10px', marginTop: '20px' },
  editBtn: {
    flex: 1, background: 'transparent', border: `1px solid ${C.border}`,
    borderRadius: '10px', padding: '12px', fontSize: '13px',
    color: C.muted, cursor: 'pointer', fontFamily: 'Georgia, serif',
    letterSpacing: '1px', textTransform: 'uppercase',
  },
  deleteBtn: {
    background: 'transparent', border: `1px solid ${C.danger}44`,
    borderRadius: '10px', padding: '12px 16px', fontSize: '13px',
    color: C.danger, cursor: 'pointer', fontFamily: 'Georgia, serif',
    letterSpacing: '1px', textTransform: 'uppercase',
  },
  saveBtn: {
    flex: 1, background: `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`,
    border: 'none', borderRadius: '10px', padding: '12px', fontSize: '13px',
    color: C.card, cursor: 'pointer', fontFamily: 'Georgia, serif',
    letterSpacing: '1px', textTransform: 'uppercase', fontWeight: '700',
  },
  input: {
    width: '100%', background: C.bg, border: `1px solid ${C.border}`,
    borderRadius: '8px', padding: '10px 14px', fontSize: '14px',
    fontFamily: 'Georgia, serif', color: C.brown, boxSizing: 'border-box',
    outline: 'none', marginBottom: '12px',
  },
  select: {
    width: '100%', background: C.bg, border: `1px solid ${C.border}`,
    borderRadius: '8px', padding: '10px 14px', fontSize: '14px',
    fontFamily: 'Georgia, serif', color: C.brown, boxSizing: 'border-box',
    outline: 'none', marginBottom: '12px', cursor: 'pointer',
    appearance: 'none', WebkitAppearance: 'none',
  },
  alert: (type) => ({
    borderRadius: '8px', padding: '10px 14px', marginBottom: '16px',
    fontSize: '13px', fontFamily: 'Calibri, sans-serif',
    background: type === 'error' ? C.dangerBg : C.successBg,
    border: `1px solid ${type === 'error' ? C.danger : C.success}44`,
    color: type === 'error' ? C.danger : C.success,
  }),
}

const frequencies = ['Weekly', 'Every 2 weeks', 'Monthly', 'Every 2 months', 'Quarterly', 'Every 6 months', 'Annually', 'As needed']
const jobStatuses = ['Scheduled', 'In Progress', 'Completed', 'On Hold', 'Cancelled']

function formatDate(dateStr) {
  if (!dateStr) return null
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  } catch { return dateStr }
}

function formatCost(cost) {
  if (!cost && cost !== 0) return null
  return `$${parseFloat(cost).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
}

export default function ServiceDetail({ service, onClose, onUpdated, onDeleted }) {
  const [mode, setMode] = useState('view')
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [logNote, setLogNote] = useState('')
  const [logCost, setLogCost] = useState('')
  const [logs, setLogs] = useState(service.logs || [])

  const [editForm, setEditForm] = useState({
    provider_name: service.provider_name || '',
    provider_phone: service.provider_phone || '',
    provider_email: service.provider_email || '',
    frequency: service.frequency || '',
    cost: service.cost || '',
    next_date: service.next_date || '',
    description: service.description || '',
    status: service.status || '',
    job_date: service.job_date || '',
    notes: service.notes || '',
  })

  const setEdit = (field) => (e) => setEditForm(f => ({ ...f, [field]: e.target.value }))

  const isRecurring = service.service_type === 'recurring'

  const saveEdit = async () => {
    setLoading(true)
    const updateData = isRecurring ? {
      provider_name: editForm.provider_name,
      provider_phone: editForm.provider_phone,
      provider_email: editForm.provider_email,
      frequency: editForm.frequency,
      cost: editForm.cost ? parseFloat(editForm.cost) : null,
      next_date: editForm.next_date || null,
      notes: editForm.notes,
    } : {
      provider_name: editForm.provider_name,
      provider_phone: editForm.provider_phone,
      provider_email: editForm.provider_email,
      description: editForm.description,
      status: editForm.status,
      cost: editForm.cost ? parseFloat(editForm.cost) : null,
      job_date: editForm.job_date || null,
      notes: editForm.notes,
    }

    const { error } = await supabase.from('services').update(updateData).eq('id', service.id)
    setLoading(false)
    if (!error) { setMode('view'); setAlert({ type: 'success', msg: 'Service updated.' }); onUpdated() }
    else setAlert({ type: 'error', msg: 'Error updating service.' })
  }

  const addLog = async () => {
    if (!logNote.trim()) return
    const newLog = {
      date: new Date().toISOString().split('T')[0],
      note: logNote.trim(),
      cost: logCost ? parseFloat(logCost) : null,
    }
    const updatedLogs = [newLog, ...logs]
    const { error } = await supabase.from('services').update({ logs: updatedLogs }).eq('id', service.id)
    if (!error) { setLogs(updatedLogs); setLogNote(''); setLogCost(''); onUpdated() }
    else setAlert({ type: 'error', msg: 'Error saving log entry.' })
  }

  const deleteService = async () => {
    setLoading(true)
    const { error } = await supabase.from('services').delete().eq('id', service.id)
    setLoading(false)
    if (!error) onDeleted()
    else setAlert({ type: 'error', msg: 'Error removing service.' })
  }

  return (
    <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={S.header}>
          <div style={S.title}>
            {mode === 'view' ? `${service.icon || '🔧'} ${service.name}` :
             mode === 'edit' ? 'Edit Service' : 'Remove Service'}
          </div>
          <button style={S.closeBtn} onClick={onClose}>×</button>
        </div>

        <div style={S.body}>
          {alert && <div style={S.alert(alert.type)}>{alert.msg}</div>}

          {/* VIEW MODE */}
          {mode === 'view' && (
            <div>
              {/* Header card */}
              <div style={S.serviceHeader}>
                <div style={S.serviceIcon}>{service.icon || '🔧'}</div>
                <div>
                  <div style={S.serviceName}>{service.name}</div>
                  <div style={S.serviceType}>
                    {isRecurring ? 'Recurring Service' : 'Contractor Job'}
                  </div>
                  {service.status && (
                    <div style={{ marginTop: '6px' }}>
                      <span style={S.statusBadge(service.status)}>{service.status}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Details */}
              <div style={S.sectionTitle}>Details</div>
              <div style={S.detailGrid}>
                {service.provider_name && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>Provider</div>
                    <div style={S.detailValue}>{service.provider_name}</div>
                  </div>
                )}
                {service.provider_phone && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>Phone</div>
                    <div style={S.detailValue}>{service.provider_phone}</div>
                  </div>
                )}
                {service.provider_email && (
                  <div style={{ ...S.detailItem, gridColumn: '1 / -1' }}>
                    <div style={S.detailLabel}>Email</div>
                    <div style={S.detailValue}>{service.provider_email}</div>
                  </div>
                )}
                {isRecurring && service.frequency && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>Frequency</div>
                    <div style={S.detailValue}>{service.frequency}</div>
                  </div>
                )}
                {service.cost && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>{isRecurring ? 'Cost / Visit' : 'Estimated Cost'}</div>
                    <div style={S.detailValue}>{formatCost(service.cost)}</div>
                  </div>
                )}
                {isRecurring && service.next_date && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>Next Scheduled</div>
                    <div style={S.detailValue}>{formatDate(service.next_date)}</div>
                  </div>
                )}
                {!isRecurring && service.job_date && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>Job Date</div>
                    <div style={S.detailValue}>{formatDate(service.job_date)}</div>
                  </div>
                )}
                {!isRecurring && service.description && (
                  <div style={{ ...S.detailItem, gridColumn: '1 / -1' }}>
                    <div style={S.detailLabel}>Description</div>
                    <div style={S.detailValue}>{service.description}</div>
                  </div>
                )}
                {service.notes && (
                  <div style={{ ...S.detailItem, gridColumn: '1 / -1' }}>
                    <div style={S.detailLabel}>Notes</div>
                    <div style={{ ...S.detailValue, fontWeight: 'normal', fontSize: '13px', lineHeight: 1.6 }}>{service.notes}</div>
                  </div>
                )}
              </div>

              <div style={S.divider} />

              {/* Service Log */}
              <div style={S.sectionTitle}>Service Log</div>
              <div style={{ marginBottom: '16px' }}>
                {logs.length === 0 ? (
                  <div style={{ fontSize: '14px', color: C.muted, fontStyle: 'italic', marginBottom: '12px' }}>
                    No visits logged yet.
                  </div>
                ) : (
                  logs.map((log, i) => (
                    <div key={i} style={S.logEntry}>
                      <div style={S.logDate}>{formatDate(log.date)}</div>
                      <div style={S.logNote}>{log.note}</div>
                      {log.cost && <div style={S.logCost}>{formatCost(log.cost)}</div>}
                    </div>
                  ))
                )}
              </div>

              {/* Add log entry */}
              <div style={{ fontSize: '11px', color: C.muted, fontFamily: 'Calibri, sans-serif', marginBottom: '8px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                Log a Visit
              </div>
              <textarea
                style={{ ...S.logInput, width: '100%', marginBottom: '8px', minHeight: '60px', boxSizing: 'border-box' }}
                placeholder="e.g. Completed spring service, treated for ants near garage..."
                value={logNote}
                onChange={e => setLogNote(e.target.value)}
              />
              <div style={{ display: 'flex', gap: '10px', marginBottom: '4px' }}>
                <input
                  style={{ ...S.logInput, flex: 1 }}
                  placeholder="Cost (optional, e.g. 150)"
                  value={logCost}
                  onChange={e => setLogCost(e.target.value)}
                  type="number"
                />
                <button style={S.logBtn} onClick={addLog}>Log Visit</button>
              </div>

              <div style={S.btnRow}>
                <button style={S.editBtn} onClick={() => { setMode('edit'); setAlert(null) }}>Edit Details</button>
                <button style={S.deleteBtn} onClick={() => setMode('confirmDelete')}>Remove</button>
              </div>
            </div>
          )}

          {/* EDIT MODE */}
          {mode === 'edit' && (
            <div>
              <div style={S.sectionTitle}>Update Service Details</div>

              <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Provider Name</label>
              <input style={S.input} value={editForm.provider_name} onChange={setEdit('provider_name')} placeholder="Provider name" autoComplete="off" />

              <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Phone</label>
              <input style={S.input} value={editForm.provider_phone} onChange={setEdit('provider_phone')} placeholder="Phone number" autoComplete="off" />

              <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Email</label>
              <input style={S.input} value={editForm.provider_email} onChange={setEdit('provider_email')} placeholder="Email address" autoComplete="off" />

              {isRecurring ? (
                <>
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Frequency</label>
                  <select style={S.select} value={editForm.frequency} onChange={setEdit('frequency')}>
                    <option value="">Select...</option>
                    {frequencies.map(f => <option key={f} value={f}>{f}</option>)}
                  </select>
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Cost per Visit</label>
                  <input style={S.input} type="number" value={editForm.cost} onChange={setEdit('cost')} placeholder="e.g. 150" autoComplete="off" />
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Next Date</label>
                  <input style={S.input} type="date" value={editForm.next_date} onChange={setEdit('next_date')} />
                </>
              ) : (
                <>
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Description</label>
                  <input style={S.input} value={editForm.description} onChange={setEdit('description')} placeholder="Job description" autoComplete="off" />
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Status</label>
                  <select style={S.select} value={editForm.status} onChange={setEdit('status')}>
                    {jobStatuses.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Cost</label>
                  <input style={S.input} type="number" value={editForm.cost} onChange={setEdit('cost')} placeholder="e.g. 350" autoComplete="off" />
                  <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Job Date</label>
                  <input style={S.input} type="date" value={editForm.job_date} onChange={setEdit('job_date')} />
                </>
              )}

              <label style={{ ...S.sectionTitle, marginBottom: '5px' }}>Notes</label>
              <input style={S.input} value={editForm.notes} onChange={setEdit('notes')} placeholder="Any additional notes" autoComplete="off" />

              <div style={S.btnRow}>
                <button style={S.editBtn} onClick={() => { setMode('view'); setAlert(null) }}>Cancel</button>
                <button style={S.saveBtn} onClick={saveEdit} disabled={loading}>
                  {loading ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </div>
          )}

          {/* CONFIRM DELETE */}
          {mode === 'confirmDelete' && (
            <div>
              <div style={{ background: C.dangerBg, border: `1px solid ${C.danger}44`, borderRadius: '10px', padding: '16px', marginBottom: '20px', fontSize: '14px', color: C.danger, fontFamily: 'Calibri, sans-serif', lineHeight: 1.6 }}>
                Are you sure you want to remove <strong>{service.name}</strong>? This will also delete all visit logs.
              </div>
              <div style={S.btnRow}>
                <button style={S.editBtn} onClick={() => setMode('view')}>Cancel</button>
                <button style={{ ...S.saveBtn, background: C.danger }} onClick={deleteService} disabled={loading}>
                  {loading ? 'Removing...' : 'Yes, Remove It'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}